import {
  MACRONUTRIENT_TO_DAILY_INTAKE_IN_PERCENTAGE_ACTION,
  MACRONUTRIENT_TO_DAILY_INTAKE_IN_PERCENTAGE_SELECT
} from '../../../../meal/constants/mapper'
import { omitObjectUtil } from 'packages/src'
import { MACRO_MIN_PERCENTAGE } from '../../../../meal/constants'

/**
 * @param macroThatWasJustUpdated
 * @returns {(function(*, *): void)|*}
 */
export function balanceDailyMacroIntakeGoalPercentageProfileAction ({
  macroThatWasJustUpdated
}) {
  return (dispatch, getState) => {
    const macroNutrientToDailyIntakeInPercentageSelectRemaining = omitObjectUtil(
      MACRONUTRIENT_TO_DAILY_INTAKE_IN_PERCENTAGE_SELECT,
      [macroThatWasJustUpdated]
    )

    const percentageSumFromRemainingMacros = Object
      .values(macroNutrientToDailyIntakeInPercentageSelectRemaining)
      .reduce((acc, curr) => acc + curr(getState()), 0)

    const macroThatWasJustUpdatedDailyIntakeInPercentage = MACRONUTRIENT_TO_DAILY_INTAKE_IN_PERCENTAGE_SELECT[macroThatWasJustUpdated](getState())
    const totalPercentageRemaining = 100 - macroThatWasJustUpdatedDailyIntakeInPercentage - percentageSumFromRemainingMacros

    const remainingMacros = Object.keys(macroNutrientToDailyIntakeInPercentageSelectRemaining)
    const macroToUpdate = remainingMacros[0]

    const macroToUpdatePercentage = MACRONUTRIENT_TO_DAILY_INTAKE_IN_PERCENTAGE_SELECT[macroToUpdate](getState())
    const newMacroToUpdatePercentage = macroToUpdatePercentage + totalPercentageRemaining
    const isNegativePercentage = newMacroToUpdatePercentage < 0
    const action = MACRONUTRIENT_TO_DAILY_INTAKE_IN_PERCENTAGE_ACTION[macroToUpdate]
    dispatch(
      action({
        value: isNegativePercentage ? MACRO_MIN_PERCENTAGE : newMacroToUpdatePercentage
      })
    )

    if (!isNegativePercentage) {
      return
    }

    const lastMacroToUpdate = remainingMacros[1]
    const lastMacroToUpdatePercentage = MACRONUTRIENT_TO_DAILY_INTAKE_IN_PERCENTAGE_SELECT[lastMacroToUpdate](getState())
    const newLastToUpdatePercentage = lastMacroToUpdatePercentage + (newMacroToUpdatePercentage - MACRO_MIN_PERCENTAGE)
    const lastMacroToUpdateAction = MACRONUTRIENT_TO_DAILY_INTAKE_IN_PERCENTAGE_ACTION[lastMacroToUpdate]
    dispatch(
      lastMacroToUpdateAction({
        value: newLastToUpdatePercentage
      })
    )
  }
}
